<template>
  <div class="instrumentLeft">
    <div class="menuItem menuItemBG" style="height:50px;">仪器设备</div>
    <div class="menuItem">仪器预约</div>
    <!-- <div class="menuItem menuItemBG" style="height:50px;">全部仪器分类</div> -->
  
    <!-- <a-menu v-model="selectedKeys" @select="deptSelect" mode="vertical">
      <template v-for="item in typeList">
        <a-menu-item v-if="!item.children" :key="item.id">
          <span>{{ item.label }}</span>
        </a-menu-item>
        <sub-menu v-else :key="item.id" :menu-info="item" />
      </template>
    </a-menu> -->

    <!-- <template v-for="item in typeList">
      <div :class="{'menuItemA': true, 'active': active === item.id}" @click="(e) => selType(e, item.id)" :key="item.id">{{ item.label }}<a-icon type="right" /></div>
    </template>

    <div class="itemBox" ref="box" v-if="showFlag">
      <div class="shade"></div>
      <div class="treeBox">
        <a-tree :load-data="onLoadData" :tree-data="treeData" />
      </div>
    </div> -->
  </div>
</template>

<script>
import { http } from '@/utils/http'
import SubMenu from './subMenu.vue'
export default {
  name: 'InstrumentLeft',
  components: {
    SubMenu,
  },
  data() {
    return {
      active: undefined,
      showFlag: false,
      treeData: [
        { title: 'Expand to load', key: '0' },
        { title: 'Expand to load', key: '1' },
        { title: 'Tree Node', key: '2', isLeaf: true },
      ],
      typeList: [],
      selectedKeys: [],
    }
  },
  watch: {
    active() {
      if (this.$route.name == 'InstrumentList') return
      else this.$router.replace({ name: 'InstrumentList' })
    }
  },
  created() {
    if (this.$route.name == 'InstrumentList') {
      this.selectedKeys = [Number(this.$route.query.deptid)]
      this.$store.commit('setTypeId', this.selectedKeys[0])
    }
    this.getTypeList()
  },
  methods: {
    // 请求获取设备类型
    getTypeList() {
      http('/reservation/getAllType', 'GET').then(res => {
        if (res.success) {
          this.typeList = res.data
        }
      })
    },
    // 树组件事件
    onLoadData(treeNode) {
      return new Promise(resolve => {
        if (treeNode.dataRef.children) {
          resolve();
          return;
        }
        setTimeout(() => {
          treeNode.dataRef.children = [
            { title: 'Child Node', key: `${treeNode.eventKey}-0` },
            { title: 'Child Node', key: `${treeNode.eventKey}-1` },
          ];
          this.treeData = [...this.treeData];
          resolve();
        }, 1000);
      });
    },
    // 分类菜单点击事件
    selType(e, i) {
      if (i === this.active) {
        this.showFlag = false
        this.active = undefined
        this.$store.commit('setTypeId', undefined)
        return
      }
      this.active = i
      this.$store.commit('setTypeId', i)
      // this.showFlag = true
      // this.$nextTick(() => {
      //   let top = e.target.offsetTop - 58
      //   this.$refs.box.style.top = top + 'px'
      //   this.active = i
      // })
    },
    // 选择部门
    deptSelect({ item, key, selectedKeys }) {
      this.selectedKeys = selectedKeys
      this.$store.commit('setTypeId', selectedKeys[0])
    },
  }
}
</script>

<style lang="less" scoped>
.instrumentLeft {
  width: 100%;
  position: relative;
  .menuItem, .menuItemA {
    min-height: 58px;
    color: #666666;
    font-weight: 400;
    padding: 0 17px;
    font-size: 16px;
    display: flex;
    align-items: center;
    display: flex;
    justify-content: space-between;
  }
  .menuItemA {
    cursor: pointer;
    min-height: unset;
    height: 50px;
    border-bottom: 1px solid #E5E5E5;
  }
  .menuItemBG {
    background: #519bcd;
    color: #FFFFFF;
  }
  .active {
    border: 2px solid #519bcd;
    // border-right: 0;
  }
  // 选中菜单弹出的窗口样式
  .itemBox {
    position: absolute;
    left: 100%;
    top: 0;
    width: 672px;
    height: 489px;
    border: 2px solid #519bcd;
    background-color: #fff;
    z-index: 99;
    border-radius: 2px;
    padding: 25px;
    .shade {
      position: absolute;
      top: 58px;
      left: -2px;
      width: 20px;
      height: 46px;
      background-color: #fff;
    }
    .treeBox {
      width: 100%;
      height: 100%;
      overflow-y: auto;
    }
  }
}
.ant-menu {
  background-color: unset;
}
.ant-menu-submenu-selected, .ant-menu-submenu-active, .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open {
  // color: #1ac158 !important;
  font-weight: 600;
}
::-webkit-scrollbar {
  width:8px;
  height:12px;
}
/* 滚动条的滑轨背景颜色 */
::-webkit-scrollbar-track {
  background-color: #b46868;
  display: none;
}
/* 滑块颜色 */
::-webkit-scrollbar-thumb {
  background-color: #c8c8c8;
  border-radius: 2px;
}
/* 滑轨两头的监听按钮颜色 */
::-webkit-scrollbar-button {
  background-color: #7c2929;
  display: none;
}
</style>
